export class ApiError extends Error {
  constructor(public status: number, public code: string, message: string) {
    super(message);
  }
}

export async function api<T>(path: string, init: { method?: string; json?: unknown } = {}): Promise<T> {
  const res = await fetch(path, {
    method: init.method ?? (init.json === undefined ? "GET" : "POST"),
    headers: init.json === undefined ? {} : { "content-type": "application/json" },
    body: init.json === undefined ? undefined : JSON.stringify(init.json),
    credentials: "same-origin",
  });
  const body = res.headers.get("content-type")?.includes("json") ? await res.json() : null;
  if (!res.ok) {
    const issue = body?.issues?.[0];
    throw new ApiError(res.status, body?.error ?? "error", body?.message ?? (issue ? `${issue.path}: ${issue.message}` : `Request failed (${res.status}).`));
  }
  return body as T;
}

export const errorText = (e: unknown) => (e instanceof Error ? e.message : "Something went wrong. Try again.");

export const fmtBytes = (n: number) =>
  n >= 1e9 ? `${(n / 1e9).toFixed(2)} GB` : n >= 1e6 ? `${(n / 1e6).toFixed(0)} MB` : `${(n / 1e3).toFixed(0)} KB`;

export const ago = (iso: string | null) => {
  if (!iso) return "never";
  const s = (Date.now() - Date.parse(iso)) / 1000;
  if (s < 3600) return `${Math.max(1, Math.round(s / 60))} min ago`;
  if (s < 86400) return `${Math.round(s / 3600)} h ago`;
  return `${Math.round(s / 86400)} d ago`;
};
